<script setup>
import SpinnerLoader from "@/components/Spinner/SpinnerLoader.vue";
import { onMounted, ref, onBeforeUnmount, nextTick, computed} from "vue";
import { useRoute } from "vue-router";
import { useLoteStore } from "@/store/loteStore";
import { iniciarSesion } from "@/utils/usuarioRedirections";
import LoteSwiper from "./componentes/LoteSwiper.vue";
import LoteFicha from "./componentes/LoteFicha.vue";
import LoteLabel from "./componentes/LoteLabel.vue";
import LoteOfertas from "./componentes/LoteOfertas.vue";
import LoteGarantia from "./componentes/LoteGarantia.vue";
import LotePestanias from "./componentes/LotePestanias.vue";
import { useUsuarioStore } from "@/store/usuarioStore";
import { Modal } from "bootstrap";
import { redirigirSubastaPortada } from "@/utils/subastaRedirections";
import { abandonarCanalDeSubastas, suscribirACanalDeSubastas } from "@/realtime/canalEventosSubastas.js";

// Instancia del store y la ruta
const loading = ref(true);
const route = useRoute();
const loteStore = useLoteStore();
const usuarioStore = useUsuarioStore();

const lote = computed(() => loteStore.lote);

const isMobile = ref(false);

const checkScreenSize = () => {
  isMobile.value = window.innerWidth < 992; // md de Bootstrap
};

onMounted(async () => {
  try {
    loading.value = true;
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    if (route.query.id) {
      await loteStore.obtenerLote(route.query.id);
      if (loteStore.lote?.puja?.length != 0) {
        await loteStore.obtenerPuja(loteStore.lote.subasta_id, loteStore.lote.id);
        await loteStore.obtenerAceptoTerminos(loteStore.lote.subasta_id);
        suscribirACanalDeSubastas(loteStore.lote.subasta, (event) => {
          loteStore.aplicarPujaActualizada(event);
        });
      }
      else {
        loteStore.calcularCargos();
      }
    }
    

    loading.value = false;

    await nextTick();
  } catch (error) {
    console.error("Error al cargar:", error);
  }
});

onBeforeUnmount(() => {
  abandonarCanalDeSubastas();
  window.removeEventListener("resize", checkScreenSize);
});

onMounted(async () => {
  await nextTick();
  abandonarCanalDeSubastas();
  if (localStorage.getItem(`prorroga_${lote?.value?.id}`) === "true") {
    const modal = new Modal(document.getElementById("prorrogaModal"));
    modal.show();
  }
});

</script>

<template>
  <div v-if="loading" class="spinner-overlay">
    <SpinnerLoader size="64px" />
  </div>

  <div class="container mt-4 text-soft-grey-74">
    <button
      @click="redirigirSubastaPortada(lote?.value?.subasta_id)"
      class="btn d-inline-flex align-items-center gap-1 text-soft-green mb-2 shadow-none bg-white"
    >
      <i class="fa fa-chevron-left fs-13 fw-semibold"></i>
      <span class="fs-13">Volver</span>
    </button>

    <div class="body-portada">
      <div class="subasta-portada">
        <LoteSwiper :loteStore="loteStore" />
      </div>
    </div>

    <div class="body my-4">
      <div class="row g-4">
        <!-- Columna izquierda -->
        <div class="col-lg-7">
          <LoteLabel :loteStore="loteStore" />

          <!-- LoteOfertas solo si hay puja -->
          <div v-if="isMobile">
            <LoteOfertas
              :loteStore="loteStore"
              :usuarioStore="usuarioStore"
            />
          </div>

          <div
            class="ficha mb-3"
            v-if="lote?.value?.caracteristicas.length != 0"
          >
            <LoteFicha :loteStore="loteStore" />
          </div>

          <LotePestanias :loteStore="loteStore" :usuarioStore="usuarioStore" />
        </div>

        <!-- Columna derecha -->
        <div class="col-lg-5">
          <div v-if="!isMobile">
            <LoteOfertas :loteStore="loteStore" />
          </div>
          <LoteGarantia v-if="lote?.value?.subasta?.tipo_credito?.slug !== 'sin-garantia'"
            :isLogged="usuarioStore.isLogged"
            @iniciarSesion="iniciarSesion"
          />
        </div>
      </div>
    </div>
  </div>
  <ProrrogaModal :loteStore="loteStore" />
</template>

<style>
.body-portada {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
}

.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 1);
  /* fondo blanco con transparencia */
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
